// @ts-nocheck
import { AccordionSectionPanel, AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import { focusStyles } from "@store/Themes/common/mixins/common";
import { css } from "styled-components";

const borderWidth = pxToRem(1);
const borderCss = css`
    ${({ theme }) => `${borderWidth} solid ${resolveColor("common.border", theme)}`}
`;

const _headerButtonBaseStyles = () => {
    return css`
        ${focusStyles()}
        padding: ${pxToRem(16, 0)};
        background-color: transparent;
        border: none;
        border-top: ${borderCss};
        border-bottom: ${borderCss};
        color: inherit;
        transition: ${transitionHoverStyles("color")};

        ${({ theme }) => css`
            font-size: ${theme.design.typography.size.large};
            font-weight: ${theme.design.typography.weight.bold};
            line-height: ${theme.design.typography.lineHeight.small};
        `}

        &[aria-expanded="true"] {
            border-bottom-color: transparent;
        }

        &:hover {
            color: ${getColor("primary.main")};
        }
    `;
};

const _headerButtonStyles = () => {
    return css`
        button {
            ${_headerButtonBaseStyles()}

            &:focus,
            &:focus-visible {
                ${_headerButtonBaseStyles()}
            }
        }
    `;
};

export const accordionFooterSectionProps: AccordionSectionPresentationProps = {
    headerProps: {
        css: css`
            ${_headerButtonStyles()}
            background-color: transparent;

            ${AccordionSectionPanel} + && {
                ${_headerButtonStyles()}
                margin-top: -${borderWidth};
            }
        `,
    },
    panelProps: {
        css: css`
            padding: ${pxToRem(0, 0, 16)};
            border: none;
            border-bottom: ${borderCss};
        `,
    },
};
